import React from "react";
import {NavLink} from "react-router-dom";

  const Error = () => {
  return (

  <section>
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12 col-sm-8">
        <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/404.png'} alt="404-img" className="img-404"/>
        <h1 className="hding-404">Oops! Page Not Found</h1>
        <p className="prgh-404"> The page you are looking for might have been removed had it's name changed or is temporarily unavailable.</p>
        <NavLink to="/" className="button-404">Back to Homepage</NavLink>
      </div>
    </div>
  </div>
</section>
    );
  };

export default Error;